import { render } from "./AssignQuestionMagement.vue?vue&type=template&id=58627c30&scoped=true"
import script from "./AssignQuestionMagement.vue?vue&type=script&lang=js"
export * from "./AssignQuestionMagement.vue?vue&type=script&lang=js"

import "./AssignQuestionMagement.vue?vue&type=style&index=0&id=58627c30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58627c30"]])

export default __exports__